import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout-page',
  standalone: true,
  imports: [],
  templateUrl: './logout-page.component.html',
  styleUrl: './logout-page.component.scss'
})
export class LogoutPageComponent implements OnInit{

  seconds: number = 5;
  private timeInterval: any;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
  ){}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
    this.startCountDown()
  }
  }
  startCountDown(): void{
    this.timeInterval = setInterval(() => {
      this.updateSeconds();
    }, 1000);
  }

  updateSeconds(): void {
    this.seconds--;
    if(this.seconds < 0){
      clearInterval(this.timeInterval);
      this.redirect();
    }
  }

  redirect():void {
    this.router.navigate(['/loginpage']);
  }
}
